export type SignInErrorKey =
	| "invalidCredentials"
	| "tooManyAttempts"
	| "accountDisabled"
	| "networkError"
	| "loginFailed";

type Matcher = readonly [needles: readonly string[], key: SignInErrorKey];

const MATCHERS: readonly Matcher[] = [
	// A missing account and a wrong password read the same: the form must not tell which addresses
	// have an account (the password reset hides it too).
	[
		["invalid-credential", "INVALID_LOGIN_CREDENTIALS", "user-not-found", "wrong-password"],
		"invalidCredentials",
	],
	[["too-many-requests"], "tooManyAttempts"],
	[["user-disabled"], "accountDisabled"],
	[["network-request-failed"], "networkError"],
];

/** Maps a Firebase sign-in failure to the `login.*` message that explains it. */
export function signInErrorKey(error: unknown): SignInErrorKey {
	if (!(error instanceof Error)) return "loginFailed";
	const code = "code" in error && typeof error.code === "string" ? error.code : "";
	const reason = code || error.message;
	return (
		MATCHERS.find(([needles]) => needles.some((n) => reason.includes(n)))?.[1] ?? "loginFailed"
	);
}
